// @flow

import type { State } from '../../types';
import { getActivePdbId } from '../../pdb';

export const productPage = (state: State) => {
  const ProductID = getActivePdbId(state);

  return ({
    pageType: 'productPage',
    email: '',
    ProductID,
  });
};

export default null;
